import { createListenerMiddleware } from '@reduxjs/toolkit'
import * as Analytics from 'analytics/analytics'
import { trackPageView } from 'analytics/snowplow/events'
// Create instance
export const analyticsListenerMiddleware = createListenerMiddleware()

analyticsListenerMiddleware.startListening({
  type: 'PAGE_VIEW',
  effect: async(action, listenerApi) => {
    const state = listenerApi.getState() as App.State
    // make sure that the first page view is correct logged with userId (if exists)
    if (state.auth.initComplete) {
      const page = state.analytics.page
      if (page.currentPath === page.prevPath) {
        return
      }

      Analytics.track('page-view', trackPageView(page.currentPath, page.currentPathParams))
    }
  },
})
